"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.geoThumbnailService = exports.GeoThumbnailService = void 0;
var GeoThumbnailWorker_1 = require("./GeoThumbnailWorker");
var PrepareThumbnailResult_1 = require("./PrepareThumbnailResult");
/**
 * The GeoThumbnailService provides a non-blocking service for converting GeoJSON into SVGs.
 * Its main use is in `GKGeoThumbnail`.
 * This is legacy code that's been moved from Insights and slightly polished.
 *
 * The GeoThumbnailService uses `GeoThumbnailWorker` to batch processing jobs at an interval.
 * It keeps a key-value list of jobs that have been requested, adding a `PrepareThumbnailResult` into each one's listeners.
 *
 * Once the `GeoThumbnailWorker` finishes a batch, it sends a worker message back to `GeoThumbnailService`.
 * That gets processed by handleWorkerMessage and sent to all listeners on a job.
 */
var GeoThumbnailService = /** @class */ (function () {
    function GeoThumbnailService() {
        var _this = this;
        /**
         * A key-string list of jobs.
         */
        this.jobs = {};
        /**
         * The GeoIconWorker owned by this service.
         * GeoIconWorker is used to batch GeoJSON processing requests.
         */
        this.worker = null;
        /**
         * If we cancel a request, pull all listeners for that job.
         */
        this.onCancelRequest = function (PrepareThumbnailResult) {
            var job = _this.jobs[PrepareThumbnailResult.jobId];
            if (job) {
                job.listeners = job.listeners.filter(function (l) { return l.id !== PrepareThumbnailResult.id; });
            }
        };
        /**
         * When we receive results, from the GeoIconWorker, this iterates over all of the matching PrepareThumbnailResults in the jobs listeners.
         */
        this.handleWorkerMessage = function (e) {
            var msg = e.data;
            var job = _this.jobs[msg.id];
            if (job) {
                job.finished = true;
                job.success = msg.success;
                job.result = msg.result;
                var listeners = job.listeners;
                job.listeners = [];
                var notify = job.success
                    ? function (l) { return l.resolve(job.result || ""); }
                    : function (l) { return l.reject(); };
                listeners.forEach(notify);
            }
        };
    }
    /**
     * Queue up GeoJSON to be converted to an icon.
     * @returns A PrepareThumbnailResult. You can attach .then to the result property to update once the SVG is ready.
     */
    GeoThumbnailService.prototype.prepareIcon = function (id, shape) {
        if (!this.worker) {
            this.startWorker();
        }
        var job = this.jobs[id];
        if (!job || job.shape !== shape) {
            this.jobs[id] = job = {
                id: id,
                shape: shape,
                result: null,
                success: false,
                finished: false,
                count: 0,
                listeners: [],
            };
            this.pushJob(job);
        }
        var result = new PrepareThumbnailResult_1.PrepareThumbnailResult(id);
        if (job.finished) {
            // no point in re-adding
            if (job.success) {
                result.resolve(job.result || "");
            }
            else {
                result.reject();
            }
        }
        else {
            // for later
            result.onCancelRequest = this.onCancelRequest;
            job.listeners.push(result);
        }
        return result;
    };
    /**
     * Create a GeoIconWorker to use.
     * Attaches onmessage to the GeoIconWorker.
     */
    GeoThumbnailService.prototype.startWorker = function () {
        this.worker = new GeoThumbnailWorker_1.GeoIconWorker();
        this.worker.onmessage = this.handleWorkerMessage;
    };
    /**
     * Sends a message to the GeoIconWorker to process a shape.
     */
    GeoThumbnailService.prototype.pushJob = function (job) {
        var msg = {
            type: GeoThumbnailWorker_1.ADD_JOB,
            id: job.id,
            shape: job.shape,
        };
        if (this.worker) {
            this.worker.postMessage(msg);
        }
    };
    return GeoThumbnailService;
}());
exports.GeoThumbnailService = GeoThumbnailService;
var service = new GeoThumbnailService();
exports.geoThumbnailService = service;
